import TYPES from "../../../ioc/types";
import container from "../../../ioc/inversify.config";

import { GeometryService } from "../../ui-services/geometry-ui-service";
import getDecorators from "inversify-inject-decorators";
import { SocketEvents } from "../../../shared/enum";
import { GameStateService } from "../../../services/game-state-service";
import { DefaultEventService } from "../../../services/event-service";
import { GameStateDTO } from "../../../shared/dtos";

const { lazyInject } = getDecorators(container);

/**
 * généraliser MenuInterface ??
 */
export interface InfoMenu {
    draw(): void;

    bindEvents(): void;

    process(): void;
}

export class DefaultInfoMenu implements InfoMenu {
    @lazyInject(TYPES.GeometryService)
    private geometryService: GeometryService;

    @lazyInject(TYPES.GameStateService)
    private gameStateService: GameStateService;

    @lazyInject(TYPES.EventService)
    private eventService: DefaultEventService;

    private _callingScene: Phaser.Scene;

    constructor(scene: Phaser.Scene) {
        this._callingScene = scene;
    }

    public draw() {
        // Info menu draw - gold display moved to party menu
    }

    public bindEvents() {
        this.eventService.register(SocketEvents.REFRESH_GAME_STATE, (data) =>
            this.updateInfos(data)
        );
    }

    public updateInfos(data) {
        console.log("update infos with data: ", data);
        const parsedData = JSON.parse(data) as GameStateDTO;
        /*        parsedData.party.characters.forEach(character => {
            const actualStats = []
            character.stats.forEach(stat => {
                actualStats.push(new StatDTO(stat))
            })
            character.stats = actualStats
        });*/
        console.log("parsed: ", parsedData);
        // Gold display removed - now shown in party menu
    }

    public process() {}

    get scene() {
        return this._callingScene;
    }
}
